import type { ExternalUser } from '@atlaskit/user-picker';
import { useCallback, useRef } from 'react';
import type { ThirdPartySource } from '../constants';

const getThirdPartyUsersKey = (source: ThirdPartySource, id: string) => `${source}:${id}`;

export const useUsersByThirdPartyId = () => {
	const usersByThirdPartyId = useRef<Map<string, ExternalUser | null>>(new Map());

	const getUserByThirdPartyId = useCallback(
		(source: ThirdPartySource, id: string) =>
			usersByThirdPartyId.current.get(getThirdPartyUsersKey(source, id)),
		[],
	);

	const cacheUserByThirdPartyId = useCallback(
		(source: ThirdPartySource, id: string, user: ExternalUser | null) =>
			usersByThirdPartyId.current.set(getThirdPartyUsersKey(source, id), user),
		[],
	);

	return { getUserByThirdPartyId, cacheUserByThirdPartyId } as const;
};
